import { useEffect } from "react";
import { REVIEWBOOST_V4_UI_ENABLED } from "../review-boost-v4-ui";

/** Internal context changes retain their existing dialog; this guards workspace exits. */
export function useUnsavedReviewGuard(dirty: boolean, slug: string) {
  useEffect(() => {
    if (!REVIEWBOOST_V4_UI_ENABLED || !dirty) return;
    const currentUrl = window.location.pathname + window.location.search;
    const permit = () => window.confirm("Tenés una respuesta sin guardar. ¿Descartar los cambios y salir?");
    const unload = (event: BeforeUnloadEvent) => { event.preventDefault(); event.returnValue = ""; };
    const click = (event: MouseEvent) => {
      if (!(event.target instanceof Element)) return;
      const control = event.target.closest("a,button");
      if (!control || control.closest(".rep-reviews-view") || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      if (control instanceof HTMLAnchorElement && control.hash && control.origin === window.location.origin && control.pathname === window.location.pathname && control.search === window.location.search) return;
      if (!permit()) { event.preventDefault(); event.stopImmediatePropagation(); }
    };
    const change = (event: Event) => {
      if (!(event.target instanceof HTMLSelectElement) || event.target.getAttribute("aria-label") !== "Cambiar negocio") return;
      if (!permit()) { event.target.value = slug; event.stopImmediatePropagation(); }
    };
    const back = (event: Event) => {
      if (window.location.pathname + window.location.search === currentUrl) return;
      if (permit()) return;
      // Cancelling restores the current route before the router sees the event.
      // It adds a history entry rather than losing the unsaved draft.
      window.history.pushState(null, "", currentUrl);
      event.preventDefault();
    };
    window.addEventListener("beforeunload", unload);
    document.addEventListener("click", click, true);
    document.addEventListener("change", change, true);
    window.addEventListener("clickdialog:before-history-navigation", back);
    return () => {
      window.removeEventListener("beforeunload", unload);
      document.removeEventListener("click", click, true);
      document.removeEventListener("change", change, true);
      window.removeEventListener("clickdialog:before-history-navigation", back);
    };
  }, [dirty, slug]);
}
